/* eslint-disable max-classes-per-file */
import TweenMax from 'gsap/umd/TweenMax';

import Module from '@/scripts/old/classes/Module';
import { findClosestElement, parseAttr } from '@/scripts/old/helpers/utils';

const NAMESPACE = 'data-spoiler';

class Spoiler {
  constructor(el) {
    this.el = el;
    this.content = el.querySelector(`[${NAMESPACE}-content]`);
    this.expanded = this.el.classList.contains('_expanded');

    const config = parseAttr(this.el, NAMESPACE);

    this.type = config.type ? config.type : '';

    if (!this.expanded) {
      this.content.style.display = 'none';
      this.el.classList.add('_collapsed');
    }

    this.onTriggerClickShim = (e) => {
      this.onTriggerClick(e);
    };

    this.setEvents();
  }

  setEvents(add = true) {
    const action = add ? 'addEventListener' : 'removeEventListener';
    this.el[action]('click', this.onTriggerClickShim);
  }

  destroy() {
    // TODO: restore initial state?
    this.setEvents(false);
  }

  onTriggerClick(e) {
    const trigger = findClosestElement(e.target, `[${NAMESPACE}-trigger]`);

    if (trigger) {
      e.preventDefault();
      if (this.expanded) {
        if (this.type === 'blink') {
          this.collapseBlink();
        } else {
          this.collapse();
        }

        return;
      }

      if (this.type === 'blink') {
        this.expandBlink();
      } else {
        this.expand();
      }
    }
  }

  collapse() {
    if (!this.expanded) return;

    const inlineOverflowStyle = this.content.style.overflow || '';
    this.content.style.overflow = 'hidden';

    this.el.classList.remove('_expanded');
    this.el.classList.add('_collapsed');

    TweenMax.to(this.content, 0.3,
      {
        height: '0px',
        ease: 'Quad.easeInOut',
        onComplete: () => {
          this.content.style.display = 'none';
          this.content.style.height = '';
          this.content.style.overflow = inlineOverflowStyle;
        },
      });

    this.expanded = false;
  }

  collapseBlink() {
    if (!this.expanded) return;

    this.el.classList.remove('_expanded');
    this.el.classList.add('_collapsed');

    TweenMax.to(this.content, 0.4,
      {
        autoAlpha: 0,
        ease: 'Quad.easeInOut',
        onComplete: () => {
          this.content.style.display = 'none';
        },
      });

    this.expanded = false;
  }

  expand() {
    if (this.expanded) return;

    const height = this.getContentHeight();
    const inlineOverflowStyle = this.content.style.overflow || '';

    this.content.style.display = '';
    this.content.style.overflow = 'hidden';

    this.el.classList.remove('_collapsed');
    this.el.classList.add('_expanded');

    TweenMax.fromTo(this.content, 0.3,
      {
        height: '0px',
      },
      {
        height,
        ease: 'Quad.easeInOut',
        onComplete: () => {
          this.content.style.height = '';
          this.content.style.overflow = inlineOverflowStyle;
        },
      });

    this.expanded = true;
  }

  expandBlink() {
    if (this.expanded) return;

    this.content.style.display = '';

    this.el.classList.remove('_collapsed');
    this.el.classList.add('_expanded');

    TweenMax.fromTo(this.content, 0.4,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        ease: 'Quad.easeInOut',
      });

    this.expanded = true;
  }

  getContentHeight() {
    if (!this.content) return 0;

    if (this.expanded) {
      return this.content.offsetHeight;
    }

    this.content.visibility = 'hidden';
    this.content.style.display = '';
    const contentHeight = this.content.offsetHeight;
    this.content.style.visibility = '';
    this.content.style.display = 'none';

    return contentHeight;
  }
}

class SpoilersModule extends Module {
  constructor() {
    super(`[${NAMESPACE}]`);
  }

  initInstance(el) {
    const spoiler = new Spoiler(el);

    this.instances.set(el, spoiler);
  }

  destroyInstance(instance) {
    instance.destroy();
  }
}

export default new SpoilersModule();
